import { createParsedInterest } from '@aikoa/common'
import { supabase } from '~/lib/supabase'

export async function getUserInterest(userId: string) {
  const { data, error } = await supabase
    .from('interests')
    .select('*')
    .eq('user_id', userId)
    .is('deleted_at', null)
    .order('created_at', { ascending: false })
    .limit(1)
    .maybeSingle()

  if (error || !data) {
    return null
  }

  return createParsedInterest(data)
}
